import { z } from "zod";

/**
 * Every category a preset is listed under; a preset has one. Historical is our history as it was,
 * Alt-Historical changes it, and Historical Fiction adds to it.
 */
export const PRESET_CATEGORIES = [
  "Historical",
  "Alt-Historical",
  "Historical Fiction",
  "Science Fiction",
  "Fantasy",
  "Creator Templates",
] as const;

export const PresetCategory = z
  .enum(PRESET_CATEGORIES)
  .meta({ id: "PresetCategory", description: "What kind of world a preset is." });
export type PresetCategory = z.infer<typeof PresetCategory>;
